import { render, staticRenderFns } from "./createNewTask.vue?vue&type=template&id=7bac4711&scoped=true"
import script from "./createNewTask.vue?vue&type=script&lang=js"
export * from "./createNewTask.vue?vue&type=script&lang=js"
import style0 from "./createNewTask.vue?vue&type=style&index=0&id=7bac4711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac4711",
  null
  
)

export default component.exports